import { pages } from 'pages/universalHub_pages';
import { getData } from 'utils/dynamicData';
// Statically import 404 to ensure we can display it
import Error404 from 'components/pages/error-404/error-404';

export const PAGE_LOADING = Symbol('loading');
export const PAGE_ERROR = Symbol('error');

const promises = {};
const data = {};

export function getPageComponent(id) {
	return data[id] || Error404;
}

export async function loadPage(id) {
	if (!id) return null;
	if (promises[id]) return promises[id];
	if (data[id]) return data[id];
	const details = pages[id];
	if (!details) return null;
	data[id] = PAGE_LOADING;
	promises[id] = (async () => {
		try {
			if (__IS_LOCAL__ || __IS_DEMO__) {
				const qs = new URLSearchParams(location.search);
				if (qs.has('test-slow')) {
					await new Promise(resolve => setTimeout(resolve, 2000));
				}
				if (qs.has('test-error')) {
					throw new Error('Test error');
				}
			}

			const dependencies = details.dataDeps || [];
			const [component] = await Promise.all([
				details.getter(),
				// Preload / cache the data (don't do anything with it)
				...dependencies.map(getData),
			]);
			data[id] = component.default;
		} catch (err) {
			console.error(err);
			data[id] = PAGE_ERROR;
		} finally {
			// Garbage collection
			delete promises[id];
		}
		return data[id];
	})();
	return promises[id];
}
